export default "__VITE_ASSET__CLCJVCmr__"